"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'landing.nav.about': 'Acerca del sistema',
    'landing.nav.modules': 'Módulos',
    'landing.nav.assistants': 'Asistentes IA',
    'landing.nav.contentStudio': 'Content Studio',
    'landing.nav.analytics': 'Analítica',
    'landing.nav.login': 'Iniciar sesión',
    'landing.hero.eyebrow': 'Plataforma IA para empresas',
    'landing.hero.title1': 'Un panel.',
    'landing.hero.title2': 'Todos los modelos IA',
    'landing.hero.title3': 'de tu empresa.',
    'landing.hero.lede': 'IntHub reúne GPT-5, Claude, Gemini y DeepSeek en un solo lugar — junto con asistentes, planificación de contenido, informes de costos y gestión de equipos. Sin cambiar entre una docena de herramientas.',
    'landing.hero.ctaLogin': 'Iniciar sesión en el panel',
    'landing.hero.ctaModules': 'Ver módulos',
    'landing.hero.note': 'testhub.intgate.io — panel disponible para empresas registradas',
    'landing.hero.deviceTitle': 'Empieza a hablar con tu asistente IA',
    'landing.hero.deviceSub': 'Elige modelo, estilo de escritura y conecta conocimiento — con un solo comando.',
    'landing.hero.deviceInput': '/ estilo · # proyecto · @ conocimiento — escribe tu pregunta…',
    'landing.model.openai': 'OpenAI · GPT-5',
    'landing.model.claudeSonnet': 'Claude Sonnet 4.6',
    'landing.model.deepseek': 'DeepSeek V3.2',
    'landing.model.gemini': 'Gemini 3.5 Flash',
    'landing.model.claudeHaiku': 'Claude Haiku 4.5',
    'landing.intro.eyebrow': 'Introducción',
    'landing.intro.title': 'Centro de mando IA para toda la organización',
    'landing.intro.lede1': 'En lugar de dispersar el trabajo entre docenas de pestañas, IntHub reúne conversaciones con modelos IA, asistentes virtuales, planificación de contenido e informes de costos en un solo sistema.',
    'landing.intro.lede2': 'El sistema es multiempresa desde su base: una cuenta administrativa puede manejar múltiples empresas, industrias y equipos, y cada operación se registra en un log de auditoría.',
    'landing.stat.providers': '4 proveedores',
    'landing.stat.providersLab': 'OpenAI, Anthropic, DeepSeek, Google — una interfaz de chat',
    'landing.stat.roles': '3 roles',
    'landing.stat.rolesLab': 'Super Admin, Manager, Usuario — permisos precisos',
    'landing.stat.multitenant': 'Multi-empresa',
    'landing.stat.multitenantLab': 'Múltiples empresas, industrias y equipos en un sistema',
    'landing.stat.credits': 'Créditos',
    'landing.stat.creditsLab': 'Facturación de uso IA en un modelo de suscripción transparente',
    'landing.modules.eyebrow': 'Módulos',
    'landing.modules.title': 'Qué encontrarás exactamente en IntHub',
    'landing.modules.lede': 'Nueve módulos, un inicio de sesión. Cada uno cubre una etapa diferente del trabajo con IA en la empresa.',
    'landing.module.chat.title': 'Chat IA multi-modelo',
    'landing.module.chat.desc': 'Chatea con GPT-5, Claude, Gemini o DeepSeek desde una ventana. Con "/" cambias estilo de escritura, "#" conectas un proyecto, "@" la base de conocimiento.',
    'landing.module.assistants.title': 'Asistentes Virtuales',
    'landing.module.assistants.desc': 'Crea avatares con personalidad, género y modelo IA propios. Cada uno pasa por una lista de tareas de entrenamiento y recibe su propia base de conocimiento.',
    'landing.module.knowledge.title': 'Base de Conocimiento',
    'landing.module.knowledge.desc': 'Conecta documentos y datos empresariales a un asistente o proyecto específico, para que las respuestas se basen en los hechos de tu empresa.',
    'landing.module.contentStudio.title': 'Content Studio',
    'landing.module.contentStudio.desc': 'Planifica publicaciones, asigna canales y rastrea el estado desde borrador hasta publicación. El asistente IA sugiere temas y mejores horarios.',
    'landing.module.styles.title': 'Estilos de Escritura',
    'landing.module.styles.desc': 'Guarda el tono de voz de tu marca — desde formal hasta jerga juvenil — y compártelo con todo el equipo con un solo interruptor.',
    'landing.module.costs.title': 'Informes de Costos',
    'landing.module.costs.desc': 'Rastrea tokens, costo por mensaje y avatares más activos desglosados por usuario, empresa y período — con gráfico de tendencia en vivo.',
    'landing.module.management.title': 'Gestión de Empresas y Equipos',
    'landing.module.management.desc': 'Gestiona múltiples empresas con módulos, industrias y profesiones separados. Asigna roles Super Admin, Manager y Usuario.',
    'landing.module.logs.title': 'Logs de Auditoría y Accesos',
    'landing.module.logs.desc': 'Cada creación y actualización de conversación, mensaje o tipo de cambio va al log de la base de datos.',
    'landing.module.pricing.title': 'Planes y Pagos',
    'landing.module.pricing.desc': 'Desde el plan gratuito hasta Ultra sin límites — usuarios, avatares y funciones crecen con tu empresa, facturados en créditos mensuales.',
    'landing.assistants.eyebrow': 'Asistentes IA',
    'landing.assistants.title': 'Un equipo de bots que crece con tu empresa',
    'landing.assistants.lede': 'Cada asistente es un empleado IA separado: modelo propio, personalidad, género y alcance de conocimiento.',
    'landing.assistants.feature1': 'Cualquier modelo para cualquier avatar — Claude, DeepSeek, Gemini',
    'landing.assistants.feature2': 'Lista de tareas de entrenamiento antes de empezar a trabajar',
    'landing.assistants.feature3': 'Base de conocimiento propia y vista de lista o cuadrícula de asistentes',
    'landing.avatar.historian': 'Historiador',
    'landing.avatar.historianRole': 'Claude Sonnet 4.6',
    'landing.avatar.hive': 'Asistente HIVE',
    'landing.avatar.hiveRole': 'DeepSeek V3.2 · Programador',
    'landing.avatar.communicator': 'Comunicador',
    'landing.avatar.communicatorRole': 'Gemini 3.5 Flash',
    'landing.avatar.whatsapp': 'Whatsapp',
    'landing.avatar.whatsappRole': 'Claude Haiku 4.5',
    'landing.avatar.statusConfig': 'Configuración completada',
    'landing.cs.eyebrow': 'Content Studio',
    'landing.cs.title': 'De la idea a la publicación, sin hojas de cálculo',
    'landing.cs.lede': 'La biblioteca de publicaciones muestra qué es borrador, qué espera aprobación y qué ya se publicó. Pregunta al asistente IA por un tema, plan semanal o mejor hora de publicación.',
    'landing.cs.feature1': 'Estados: borrador, programado, pendiente aprobación, publicado',
    'landing.cs.feature2': 'Calendario e historial de publicaciones en un solo lugar',
    'landing.cs.feature3': 'El asistente IA sugiere temas basados en engagement',
    'landing.cs.statScheduled': 'Programados (7 días)',
    'landing.cs.statApproval': 'Pendiente aprobación',
    'landing.cs.statPublished': 'Publicados (30 días)',
    'landing.cs.statTotal': 'Total publicaciones',
    'landing.cs.postTitle': 'Probando la API',
    'landing.cs.postStatus': 'Publicado',
    'landing.cs.postContent': '"¡Hola! Hoy mostramos cómo probar una API paso a paso…"',
    'landing.cs.suggest1': '¿Qué temas traerán mejor engagement?',
    'landing.cs.suggest2': 'Sugiere un plan de contenido para la próxima semana',
    'landing.cs.suggest3': '¿Cuándo es mejor publicar?',
    'landing.analytics.eyebrow': 'Analítica',
    'landing.analytics.title': 'Cada token contabilizado hasta el céntimo',
    'landing.analytics.lede': 'Filtra informes de costos por fecha, usuario, avatar o empresa.',
    'landing.analytics.feature1': 'Filtros por fecha, usuario, avatar y empresa',
    'landing.analytics.feature2': 'Gráfico de tendencia de costos y tokens en el tiempo',
    'landing.analytics.feature3': 'Ranking del avatar más activo en la organización',
    'landing.analytics.totalCost': 'Costo total',
    'landing.analytics.tokens': 'Tokens',
    'landing.analytics.messages': 'Mensajes',
    'landing.analytics.avgCost': 'Costo prom. / mensaje',
    'landing.analytics.topMessages': 'Mensajes del avatar top',
    'landing.analytics.topAvatar': 'Avatar top',
    'landing.management.eyebrow': 'Gestión y seguridad',
    'landing.management.title': 'Estructura multi-empresa, control en cada nivel',
    'landing.management.lede': 'Una instalación maneja múltiples empresas, industrias y profesiones — y cada cambio queda registrado.',
    'landing.management.companies.title': 'Empresas, usuarios, roles',
    'landing.management.companies.desc': 'Agrega empresas con NIP, dirección y módulos asignados. Asigna a cada cuenta un rol.',
    'landing.management.logs.title': 'Logs de auditoría de la base de datos',
    'landing.management.logs.desc': 'Filtra logs por fecha, modelo y tipo de operación. Para cada entrada verás datos exactos y resultado.',
    'landing.management.table.company': 'Empresa',
    'landing.management.table.city': 'Ciudad',
    'landing.management.table.status': 'Estado',
    'landing.management.table.model': 'Modelo',
    'landing.management.table.operation': 'Operación',
    'landing.management.table.date': 'Fecha',
    'landing.management.company1': 'Studio Nord Sp. z o.o.',
    'landing.management.company2': 'Kancelaria Wschód',
    'landing.management.company3': 'Biuro Rachunkowe Miller',
    'landing.management.warsaw': 'Varsovia',
    'landing.management.krakow': 'Cracovia',
    'landing.management.elk': 'Ełk',
    'landing.management.active': 'Activa',
    'landing.management.opConversation': 'Conversación',
    'landing.management.opMessage': 'Mensaje',
    'landing.management.opCurrency': 'Tipo de cambio',
    'landing.management.opCreate': 'Crear',
    'landing.management.opUpdate': 'Actualizar',
    'landing.cta.eyebrow': 'Listo para empezar',
    'landing.cta.title': 'Centraliza IA en tu empresa hoy',
    'landing.cta.lede': 'Inicia sesión en el panel de prueba y configura tu primer asistente en minutos.',
    'landing.cta.button': 'Ir al inicio de sesión',
    'landing.footer.copyright': '© 2026 IntHub. Todos los derechos reservados.',
    'landing.footer.panel': 'Panel de acceso',
    'landing.img.logo': 'IntHub',
    'landing.img.bg1': 'Estación de trabajo con IA',
};
